import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Text, View, StyleSheet, Platform } from 'react-native';

import Theme from '../../theme';
import { ChevronRightIcon, ChevronRightBlackIcon } from '../../ui/components/Icons'
import MealImage from './MealImage';
import { UserDataConsumer } from '../../utils';
import { Tile } from '../../ui/components';
import { Icon } from '../../components';
import theme from '../../theme';
import { defaultScale } from '../../utils/scaling';


class MealRow extends Component {
    render() {
        const { t,
            meal,
            mealOfDay,
            isDashboard = false,
            dayText = {},
            mealContainer = {},
            mealTitleContainerDash,
            mealImageBorderRadius = 0,
            openMealModal, closeMealModal, navigateToNutrition } = this.props
        const mealCalories = isDashboard ? ` (${Math.round(meal.calories)} Cals)` : '';
        return (
            <Tile customStyle={[styles.container]} onPress={() => {
                if (isDashboard) {
                    navigateToNutrition();
                } else {
                    closeMealModal();
                    openMealModal(mealOfDay, meal);
                }
            }}>
                <View style={styles.mealDetailsContainer}>
                    <MealImage
                        mealImagUrl={meal.urlForThumbImage ? meal.urlForThumbImage : null}
                        t={t}
                        mealImageBorderRadius={mealImageBorderRadius}
                    />
                    <View style={mealTitleContainerDash ? mealTitleContainerDash : styles.mealTitleContainer}>
                        <Text style={[styles.mealOfDay, dayText]}>{t(mealOfDay)} {mealCalories}</Text>
                        <Text style={styles.mealTitle}>{meal.displayName}</Text>
                    </View>
                </View>
                {!isDashboard &&
                    <View style={styles.arrowContainer}>
                        <Icon
                            size={defaultScale(14)}
                            color={Theme.GREY_DARK_MEDIUM}
                            name="ios-arrow-forward"
                        />
                    </View>
                }
            </Tile>
        )
    }
}

MealRow.propTypes = {
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Theme.WHITE,
        flexDirection: 'row',
        paddingHorizontal: defaultScale(10),
        paddingVertical: defaultScale(5),
        height: defaultScale(100),
        marginBottom: defaultScale(5),
        borderRadius: 0,
    },
    arrowContainer: {
        alignSelf: 'center',
    },
    mealDetailsContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    mealTitleContainer: {
        flex: 1,
        paddingLeft: defaultScale(10),
        flexWrap: 'wrap',
        flexDirection: 'column',
    },
    mealOfDay: {
        ...theme.textStyle.bodyCopyBold,
        flexWrap: 'wrap',
        color: Theme.DARK_CHARCOAL,
        width: '100%',
    },
    mealTitle: {
        ...theme.textStyle.bodyCopyReg,
        color: Theme.DARK_CHARCOAL,
        flexWrap: 'wrap',
        width: '100%',
    },
    openButton: {
        flex: 1,
        alignItems: 'flex-end',
        justifyContent: 'center',
        width: '20%',
    },
});

MealRow = UserDataConsumer(MealRow);
export default translate(['nutrition'], { wait: true })(MealRow);

